import AuthLayout from "@Organism/Auth";

const AuthPage = ({ type }) => {
  return (
    <AuthLayout type={type} />
  );
};

export default AuthPage;
